import s from './InlineHeader.module.sass';

import { FC } from 'react';

export const InlineHeader: FC = ({ children }) => {
  return <div className={s.header}>{children}</div>;
};
